import type { RegexPattern } from '../types';

/**
 * @group Constants
 * @summary <blockquote>Regex patterns for extracting JSON from mixed text.</blockquote>
 *
 * Used when content may contain JSON objects or arrays alongside other text.
 */
export const JSON_EXTRACTION_PATTERNS = {
  /**
   * Matches a JSON object (greedy, for extraction from mixed content)
   * Example: "Here is the result: {\"a\": 1}" → captures {"a": 1}
   */
  JSON_OBJECT: {
    regex: /(\{[\s\S]*\})/,
    description: 'Matches a JSON object in text (first capture group is the object)',
    examples: ['{"a": 1}', '{"nested": {"b": 2}}'],
    counterExamples: ['[1, 2]', 'plain text'],
  } as RegexPattern,

  /**
   * Matches a JSON array (greedy, for extraction from mixed content)
   * Example: "Data: [1, 2, 3]" → captures [1, 2, 3]
   */
  JSON_ARRAY: {
    regex: /(\[[\s\S]*\])/,
    description: 'Matches a JSON array in text (first capture group is the array)',
    examples: ['[1, 2, 3]', '[{"id": 1}]'],
    counterExamples: ['{"a": 1}', 'plain text'],
  } as RegexPattern,
} as const;
